import styled from 'styled-components';

import { BasicParagraph } from '@genially/design-system';

import { PANEL_SURFACE } from '../common/panelColors';
import type { ScoreTone } from './utils/getScoreTone';

interface ListProps {
  $isBlurred: boolean;
}

export const List = styled.div<ListProps>(
  ({ theme: { size, transition }, $isBlurred }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: size.units(1),
    transition: transition.standard('filter', 'opacity'),

    // Blurred and faded rather than hidden: the host can see there is something behind the
    // veil, and it takes a deliberate gesture to put names in front of the room.
    ...($isBlurred
      ? { filter: 'blur(6px)', opacity: 0.3, pointerEvents: 'none', userSelect: 'none' }
      : {}),
  }),
);

export const Row = styled.div(({ theme: { color, size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1.5),
  padding: size.units(1.5),
  borderRadius: size.units(1),
  backgroundColor: PANEL_SURFACE,
}));

export const Name = styled(BasicParagraph)(({ theme: { color } }) => ({
  flex: 1,
  color: color.content.reversed.default(),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

interface ScoreProps {
  $tone: ScoreTone;
}

export const Score = styled(BasicParagraph)<ScoreProps>(({ theme: { color }, $tone }) => {
  const toneColor = {
    good: color.content.success.default,
    fair: color.content.warning.default,
    poor: color.content.error.default,
    neutral: color.content.reversed.default,
  }[$tone];

  return { color: toneColor(), flexShrink: 0 };
});
